import Action from './baseActions';
import {
  IBlock,
} from '../../models';

// Types

export enum BlockResultActionsTypes {
  EXECUTE_BLOCK = 'block-result/execute_block',
  EXECUTING_BLOCK = 'block-result/executing_block',
  EXECUTED_BLOCK = 'block-result/executed_block',
  EXECUTING_BLOCK_FAILED = 'block-result/executing_block_failed',
  CHECK_BLOCK_EXECUTION = 'block-result/check_block_execution',
  UNSET_BLOCK_EXECUTION = 'block-result/unset_block_execution',
  UNSET_BLOCK_EXECUTIONS = 'block-result/unset_block_executions',

  STOP_SQL_BLOCK_EXECUTION = 'block-result/stop_sql_block_execution',
  STOPPING_SQL_BLOCK_EXECUTION = 'block-result/stopping_sql_block_execution',
  STOPPED_SQL_BLOCK_EXECUTION = 'block-result/stopped_sql_block_execution',
  STOPPING_SQL_BLOCK_EXECUTION_FAILED = 'block-result/stopping_sql_block_execution_failed',

  LOAD_BLOCK_RESULT = 'block-result/load_block_result',
  LOADING_BLOCK_RESULT = 'block-result/loading_block_result',
  LOADED_BLOCK_RESULT = 'block-result/loaded_block_result',
  LOADING_BLOCK_RESULT_FAILED = 'block-result/loading_block_result_failed',

  LOAD_BLOCK_RESULTS = 'block-result/load_block_results',
  LOADING_BLOCK_RESULTS = 'block-result/loading_block_results',
  LOADED_BLOCK_RESULTS = 'block-result/loaded_block_results',
  LOADING_BLOCK_RESULTS_FAILED = 'block-result/loading_block_results_failed',

  ADD_BLOCK_RESULT = 'block-result/add_block_result',
  UPDATE_BLOCK_RESULT = 'block-result/update_block_result',
}

// Interfaces

export interface IExecuteBlockAction extends Action {
  type: BlockResultActionsTypes.EXECUTE_BLOCK;
  payload: {
    uid: string;
    reportUid: string | null;
    block?: IBlock | null;
  }
}

export interface IExecutingBlockAction extends Action {
  type: BlockResultActionsTypes.EXECUTING_BLOCK;
}

export interface IExecutedBlockAction extends Action {
  type: BlockResultActionsTypes.EXECUTED_BLOCK;
  payload: {
    uid: string;
    resultId: string;
    result: any;
  }
}

export interface IExecutingBlockFailedAction extends Action {
  type: BlockResultActionsTypes.EXECUTING_BLOCK_FAILED;
  payload: {
    uid: string;
    resultId?: string;
  }
}

export interface ICheckBlockExecution extends Action {
  type: BlockResultActionsTypes.CHECK_BLOCK_EXECUTION;
  payload: {
    uid: string;
    resultId: string;
    counter: number; // safety check; check until,
  };
}

export interface IUnsetBlockExecution extends Action {
  type: BlockResultActionsTypes.UNSET_BLOCK_EXECUTION;
  payload: string;
}

export interface IUnsetBlockExecutions extends Action {
  type: BlockResultActionsTypes.UNSET_BLOCK_EXECUTIONS;
}

export interface IStopSqlBlockExecution extends Action {
  type: BlockResultActionsTypes.STOP_SQL_BLOCK_EXECUTION;
  payload: {
    uid: string;
    resultId: string;
  }
}

export interface IStoppingSqlBlockExecution extends Action {
  type: BlockResultActionsTypes.STOPPING_SQL_BLOCK_EXECUTION;
}

export interface IStoppedSqlBlockExecution extends Action {
  type: BlockResultActionsTypes.STOPPED_SQL_BLOCK_EXECUTION;
  payload: {
    uid: string;
    resultId: string;
  }
}

export interface IStoppingSqlBlockExecutionFailed extends Action {
  type: BlockResultActionsTypes.STOPPING_SQL_BLOCK_EXECUTION_FAILED;
}

export interface ILoadBlockResultAction extends Action {
  type: BlockResultActionsTypes.LOAD_BLOCK_RESULT;
  payload: {
    uid: string;
    resultId: string;
  }
}

export interface ILoadingBlockResultAction extends Action {
  type: BlockResultActionsTypes.LOADING_BLOCK_RESULT;
}

export interface ILoadedBlockResultAction extends Action {
  type: BlockResultActionsTypes.LOADED_BLOCK_RESULT;
  payload: any; // ???
}

export interface ILoadingBlockResultFailedAction extends Action {
  type: BlockResultActionsTypes.LOADING_BLOCK_RESULT_FAILED;
}

export interface ILoadBlockResultsAction extends Action {
  type: BlockResultActionsTypes.LOAD_BLOCK_RESULTS;
  payload: string;
}

export interface ILoadingBlockResultsAction extends Action {
  type: BlockResultActionsTypes.LOADING_BLOCK_RESULTS;
}

export interface ILoadedBlockResultsAction extends Action {
  type: BlockResultActionsTypes.LOADED_BLOCK_RESULTS;
  payload: any; // ???
}

export interface ILoadingBlockResultsFailedAction extends Action {
  type: BlockResultActionsTypes.LOADING_BLOCK_RESULTS_FAILED;
}

export interface IAddBlockResultAction extends Action {
  type: BlockResultActionsTypes.ADD_BLOCK_RESULT;
  payload: {
    uid: string;
    resultId: string;
    result: any;
  };
}

export interface IUpdateBlockResultAction extends Action {
  type: BlockResultActionsTypes.UPDATE_BLOCK_RESULT;
  payload: {
    uid: string;
    resultId: string;
    result: any;
  };
}

// Functions

export function executeBlock(
  uid: string,
  reportUid: string | null,
  block: IBlock | null = null
): IExecuteBlockAction {
  return {
    type: BlockResultActionsTypes.EXECUTE_BLOCK,
    payload: {
      uid,
      reportUid,
      block,
    }
  }
}

export function executingBlock(): IExecutingBlockAction {
  return {
    type: BlockResultActionsTypes.EXECUTING_BLOCK
  }
}

export function executedBlock(uid: string, resultId: string, result: any): IExecutedBlockAction {
  return {
    type: BlockResultActionsTypes.EXECUTED_BLOCK,
    payload: {
      uid,
      resultId,
      result,
    },
  }
}

export function executingBlockFailed(uid: string, resultId?: string): IExecutingBlockFailedAction {
  return {
    type: BlockResultActionsTypes.EXECUTING_BLOCK_FAILED,
    payload: {
      uid,
      resultId,
    }
  }
}

export function checkBlockExecution(
  uid: string,
  resultId: string,
  counter: number = 0,
): ICheckBlockExecution {
  return {
    type: BlockResultActionsTypes.CHECK_BLOCK_EXECUTION,
    payload: {
      uid,
      resultId,
      counter,
    }
  }
}

export function unsetBlockExecution(uid: string): IUnsetBlockExecution {
  /*
   * unset executionStatus
   */
  return {
    type: BlockResultActionsTypes.UNSET_BLOCK_EXECUTION,
    payload: uid
  }
}

export function unsetBlockExecutions(): IUnsetBlockExecutions {
  return {
    type: BlockResultActionsTypes.UNSET_BLOCK_EXECUTIONS,
  }
}

export function stopSqlBlockExecution(uid: string, resultId: string): IStopSqlBlockExecution {
  /*
   * Set Pending query execution status to failed
   */
  return {
    type: BlockResultActionsTypes.STOP_SQL_BLOCK_EXECUTION,
    payload: {
      uid,
      resultId,
    }
  }
}

export function stoppingSqlBlockExecution(): IStoppingSqlBlockExecution {
  return {
    type: BlockResultActionsTypes.STOPPING_SQL_BLOCK_EXECUTION,
  }
}

export function stoppedSqlBlockExecution(uid: string, resultId: string): IStoppedSqlBlockExecution {
  return {
    type: BlockResultActionsTypes.STOPPED_SQL_BLOCK_EXECUTION,
    payload: {
      uid,
      resultId,
    }
  }
}

export function stoppingSqlBlockExecutionFailed(): IStoppingSqlBlockExecutionFailed {
  return {
    type: BlockResultActionsTypes.STOPPING_SQL_BLOCK_EXECUTION_FAILED,
  }
}

export function loadBlockResult(uid: string, resultId: string): ILoadBlockResultAction {
  return {
    type: BlockResultActionsTypes.LOAD_BLOCK_RESULT,
    payload: {
      uid,
      resultId,
    }
  }
}

export function loadingBlockResult(): ILoadingBlockResultAction {
  return {
    type: BlockResultActionsTypes.LOADING_BLOCK_RESULT
  }
}

export function loadedBlockResult(result: any): ILoadedBlockResultAction {
  return {
    type: BlockResultActionsTypes.LOADED_BLOCK_RESULT,
    payload: result
  }
}

export function loadingBlockResultFailed(): ILoadingBlockResultFailedAction {
  return {
    type: BlockResultActionsTypes.LOADING_BLOCK_RESULT_FAILED
  }
}

export function loadBlockResults(uid: string): ILoadBlockResultsAction {
  return {
    type: BlockResultActionsTypes.LOAD_BLOCK_RESULTS,
    payload: uid
  }
}

export function loadingBlockResults(): ILoadingBlockResultsAction {
  return {
    type: BlockResultActionsTypes.LOADING_BLOCK_RESULTS
  }
}

export function loadedBlockResults(result: any): ILoadedBlockResultsAction {
  return {
    type: BlockResultActionsTypes.LOADED_BLOCK_RESULTS,
    payload: result
  }
}

export function loadingBlockResultsFailed(): ILoadingBlockResultsFailedAction {
  return {
    type: BlockResultActionsTypes.LOADING_BLOCK_RESULTS_FAILED
  }
}

export function addBlockResult(uid: string, resultId: string, result: any): IAddBlockResultAction {
  return {
    type: BlockResultActionsTypes.ADD_BLOCK_RESULT,
    payload: {
      uid,
      resultId,
      result,
    }
  }
}

export function updateBlockResult(uid: string, resultId: string, result: any): IUpdateBlockResultAction {
  return {
    type: BlockResultActionsTypes.UPDATE_BLOCK_RESULT,
    payload: {
      uid,
      resultId,
      result,
    }
  }
}

export type BlockResultActions =
  IExecuteBlockAction |
  IExecutingBlockAction |
  IExecutedBlockAction |
  IExecutingBlockFailedAction |
  ICheckBlockExecution |
  IUnsetBlockExecution |
  IUnsetBlockExecutions |
  IStopSqlBlockExecution |
  IStoppingSqlBlockExecution |
  IStoppedSqlBlockExecution |
  IStoppingSqlBlockExecutionFailed |
  ILoadBlockResultAction |
  ILoadingBlockResultAction |
  ILoadedBlockResultAction |
  ILoadingBlockResultFailedAction |
  ILoadBlockResultsAction |
  ILoadingBlockResultsAction |
  ILoadedBlockResultsAction |
  ILoadingBlockResultsFailedAction |
  IAddBlockResultAction |
  IUpdateBlockResultAction;
